import fallbackImage from "@/components/fallback.jpg";
import { blurHashToDataURL } from "@/lib/blurhashDataURL";
import { safeJsonParse } from "@/lib/safeJsonParse";
import { cn } from "@/lib/utils";
import Image from "next/image";
import { useState } from "react";

export const makeBlurhashFallback = (blurhash?: string) => {
  return blurhash
    ? blurHashToDataURL(blurhash)
    : blurHashToDataURL("L5Q,E.0000x]=e-V-;0K.9.SXm_N");
};

export const ImageWithFallback = ({
  fallback = fallbackImage,
  alt,
  src,
  className,
  ...props
}: any) => {
  const srcObj = safeJsonParse(src);

  const scaleFactor = Math.min(800 / srcObj.width, 800 / srcObj.height);

  const [isReady, setIsReady] = useState(false);

  const onLoadCallback = () => {
    setIsReady(true);
  };

  if (srcObj?.filename) {
    return (
      <Image
        alt={alt}
        src={process.env.BASE_FILE_BUCKET_URL + "/storage/" + srcObj?.filename}
        blurDataURL={makeBlurhashFallback(srcObj?.blurhash)}
        placeholder="blur"
        className={cn(
          `transition duration-300 ${
            isReady ? "scale-100 blur-0" : "scale-120 blur-xl"
          }`,
          className,
        )}
        width={srcObj?.width * scaleFactor || 500}
        height={srcObj?.height * scaleFactor || 500}
        onLoad={onLoadCallback}
        {...props}
      />
    );
  }
};
